<template>
    <div class="container">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="text-center mt-4 mb-4">
                    <h1 class="display-4">Política de Privacidad</h1>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Condiciones Generales</h5>
                        <p>
                            Al descargar o usar la app, estos términos se aplicarán automáticamente a usted; por lo tanto,
                            asegúrese de leerlos detenidamente antes de usar la app.
                        </p>
                        <p>
                            No está permitido copiar ni modificar la app, ninguna parte de la app ni nuestras marcas de ninguna manera.
                        </p>
                        <p>
                            No está permitido intentar extraer el código fuente de la app, ni debe intentar traducir la app a otros idiomas
                            ni crear versiones derivadas.
                        </p>
                        <p>
                            La app y todas las marcas, derechos de autor, derechos de base de datos y demás derechos de propiedad intelectual
                            relacionados siguen perteneciendo a Florian Zopf.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Cambios en el Servicio y Cargos</h5>
                        <p>
                            Florian Zopf se compromete a garantizar que la app sea lo más útil y eficiente posible.
                        </p>
                        <p>
                            Nos reservamos el derecho de realizar cambios en la app o de cobrar por sus servicios,
                            en cualquier momento y por cualquier motivo.
                        </p>
                        <p>
                            Nunca le cobraremos por la app o sus servicios sin dejarle muy claro exactamente por qué está pagando.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Seguridad de Datos y Privacidad</h5>
                        <p>
                            La app Qwik VBT almacena y procesa los datos personales que usted nos ha proporcionado para poder prestar el Servicio.
                        </p>
                        <p>
                            Para ofrecer el modo en línea, almacenamos los datos de los usuarios en la nube. Nos tomamos muy en serio la privacidad
                            y la seguridad de sus datos e implementamos medidas estándar de la industria para protegerlos contra el acceso, la divulgación,
                            la alteración y la destrucción no autorizados.
                        </p>
                        <p>
                            Sin embargo, ningún método de almacenamiento electrónico o de transmisión por Internet es 100% seguro,
                            y no podemos garantizar la seguridad absoluta de sus datos.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Servicios de Terceros</h5>
                        <p>
                            La app utiliza servicios de terceros que publican sus Términos y Condiciones.
                        </p>
                        <p>
                            Enlace a los Términos y Condiciones de los proveedores de servicios de terceros utilizados por la app:
                        </p>
                        <ul>
                            <li><a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Google
                                    Play
                                    Services</a></li>
                        </ul>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Inicio de sesión con Google</h5>
                        <p>
                            En nuestra app, ofrecemos la opción de iniciar sesión con Google para su comodidad. Este proceso requiere acceder
                            a su dirección de correo electrónico, que utilizamos únicamente como identificador único dentro de nuestra app.
                            Respetamos su privacidad: su correo electrónico nunca se comparte, se vende ni se utiliza para ningún otro propósito.
                            Al elegir iniciar sesión con Google, usted consiente este uso limitado de su dirección de correo electrónico.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Responsabilidad y Uso</h5>
                        <p>
                            Florian Zopf no puede responsabilizarse de que la app no funcione con todas sus funciones si usted no tiene acceso a Wi‑Fi
                            y no le queda franquicia de datos.
                        </p>
                        <p>
                            Del mismo modo, Florian Zopf no siempre puede responsabilizarse de la forma en que usted utiliza la app; por ejemplo,
                            debe asegurarse de que su dispositivo permanezca cargado.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Actualizaciones y Terminación</h5>
                        <p>
                            En algún momento, podemos desear actualizar la app. Florian Zopf no promete que siempre actualizará la app para que sea
                            relevante para usted o para que funcione con la versión de Android e iOS instalada en su dispositivo.
                        </p>
                        <p>
                            Sin embargo, usted se compromete o promete aceptar siempre las actualizaciones de la aplicación cuando se le ofrezcan.
                            También podemos dejar de proporcionar la app y terminar su uso en cualquier momento sin previo aviso.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Instrucciones y Funcionamiento Óptimo</h5>
                        <p>
                            Es fundamental que los usuarios sigan las instrucciones proporcionadas en la app para garantizar su funcionamiento óptimo.
                        </p>
                        <p>
                            No seguir las instrucciones puede dar lugar a resultados inexactos y la app puede no funcionar como se pretende.
                            Florian Zopf no se hace responsable de los problemas o inexactitudes que surjan por no seguir las instrucciones de la app.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Cambios en los Términos y Condiciones</h5>
                        <p>
                            Podemos actualizar nuestros términos y condiciones de vez en cuando para reflejar cambios en nuestra app y servicios.
                        </p>
                        <p>
                            El uso continuado de la app constituye la aceptación de los nuevos términos y condiciones. Le recomendamos que revise
                            periódicamente los términos y condiciones para ver si hay actualizaciones.
                        </p>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-body">
                        <h5 class="card-title">Contáctanos</h5>
                        <p>
                            Si tiene alguna pregunta o sugerencia sobre nuestros Términos y Condiciones, no dude en contactarnos en
                            qwikvbt@gmail.com.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div></template>


